import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {CostTranshipmentState} from "@/interfaces/state/costtranshipment";
import {IdMapper} from "@/interfaces/state/base";
import {CostTranshipment} from "@/interfaces/entity/costtranshipment";
import {PaginationMeta} from "@/interfaces/common";
import {CostTranshipmentParams} from "@/modules/receiptsexpenses/updatecosttranshipment/params";
import store from "@/store";
import {union} from "lodash";
import {createCostTranshipment, listCostTranshipment, singleCostTranshipment, updateCostTranshipment} from './services';

@Module({dynamic: true, name: "costTranshipmentStore", store})
class CostTranshipmentModule extends VuexModule implements CostTranshipmentState {
    data: IdMapper<CostTranshipment> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: CostTranshipmentParams = new CostTranshipmentParams();

    get costTranshipments() {
        return this.ids.map((id: number) => this.data[id]);
    }

    @Mutation
    private MAP_COST_TRANSHIPMENT(payload: any) {
        const idMapper: IdMapper<CostTranshipment> = {};
        this.meta = payload.meta;
        this.ids = payload.datas?.map((cost: CostTranshipment, index: number) => {
            idMapper[cost.id] = {...cost, stt: index + 1};
            return cost.id;
        });
        this.data = idMapper;
    }

    @Mutation
    private SET_COST_TRANSHIPMENT(payload: any) {
        this.ids = union(this.ids, [payload.id]);
        this.data[payload.id] = {...payload}
        this.ids.forEach((item, index) => {
            this.data[item] = {...this.data[item], stt: index + 1};
        })

    }

    @Mutation
    private UPDATE_PARAMS_COST_TRANSHIPMENT(payload: any) {
        this.params = payload;
    }

    @Action({rawError: true})
    public async listCostTranshipment(params: any) {
        const {data} = await listCostTranshipment(params);
        this.MAP_COST_TRANSHIPMENT(data);
    }

    @Action({rawError: true})
    public updateParamsCostTranshipment(payload: any) {
        this.UPDATE_PARAMS_COST_TRANSHIPMENT(payload);
    }

    @Action({rawError: true})
    public async singleCostTranshipment(id: number): Promise<CostTranshipment> {
        const {data} = await singleCostTranshipment(id)
        return data.data
    }

    @Action({rawError: true})
    public async updateCostTranshipment(payload: any) {
        const {data} = await updateCostTranshipment(payload);
        this.SET_COST_TRANSHIPMENT(data.data);
    }

    @Action({rawError: true})
    public async createCostTranshipment(payload: any) {
        const {data} = await createCostTranshipment(payload);
        this.SET_COST_TRANSHIPMENT(data.data);
    }

}

export const CostTranshipmentStore = getModule(CostTranshipmentModule)
